import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {App} from './app';
import '@/public/globals.css';
import {buildDependencies} from './dependencies';
import {registerServiceWorker} from './lib/register-service-worker';

function bootstrap() {
  const deps = buildDependencies();
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Root element not found');
  }

  createRoot(rootElement).render(
    <StrictMode>
      <App deps={deps} />
    </StrictMode>,
  );

  registerServiceWorker();
}

bootstrap();
